import AbsenceUnJustifiedWidget from "./AbsenceUnJustifiedWidget.vue";
import AbsenceJustifiedWidget from "./AbsenceJustifiedWidget.vue";
import AbsenceConfirmWaitingWidget from "./AbsenceConfirmWaitingWidget.vue";

export { AbsenceUnJustifiedWidget, AbsenceJustifiedWidget, AbsenceConfirmWaitingWidget };
